import { graphql } from './api';

/** Customer posts (MVP_PHASES.md 7b, Plus): posts where shoppers tagged the store, approved by the merchant. */

export type ModerationStatus = 'pending' | 'approved' | 'rejected';
export type CustomerPost = {
  id: string;
  author: string;
  caption: string;
  permalink: string;
  mediaType: string;
  postedAt: string | null;
  status: ModerationStatus;
  processingStatus: string;
  thumbnailUrl: string;
};
export type CustomerPostsInfo = { available: boolean; allowed: boolean; scopeGranted: boolean; requireApproval: boolean; pending: number };

const INFO = 'available allowed scopeGranted requireApproval pending';

export function loadInfo() {
  return graphql<{ customerPostsInfo: CustomerPostsInfo }>(`{ customerPostsInfo { ${INFO} } }`).then(d => d.customerPostsInfo);
}

export function loadPosts(status: ModerationStatus) {
  return graphql<{ customerPosts: CustomerPost[] }>(
    `query Posts($status: String!) { customerPosts(status: $status) { id author caption permalink mediaType postedAt status processingStatus thumbnailUrl } }`,
    { status },
  ).then(d => d.customerPosts);
}

export async function moderate(ids: string[], status: ModerationStatus): Promise<number> {
  const data = await graphql<{ moderateCustomerPosts: number }>(
    `mutation Moderate($ids: [ID!]!, $status: String!) { moderateCustomerPosts(ids: $ids, status: $status) }`,
    { ids, status },
  );
  return data.moderateCustomerPosts;
}

export async function setRequireApproval(required: boolean): Promise<boolean> {
  const data = await graphql<{ setCustomerPostsApproval: boolean }>(
    `mutation Approval($required: Boolean!) { setCustomerPostsApproval(required: $required) }`,
    { required },
  );
  return data.setCustomerPostsApproval;
}
